import * as React from "react";
import { SVGProps } from "react";

const NoResults = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 365.83 294.8"
    width={406}
    height={306}
    className="illustration styles_illustrationTablet__1DWOa"
    {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={356.6}
        y1={161.95}
        x2={252.42}
        y2={198.82}
        gradientTransform="rotate(17.35 706.17 -262.737) scale(1.01)"
        gradientUnits="userSpaceOnUse">
        <stop offset={0.01} />
        <stop offset={0.13} stopOpacity={0.69} />
        <stop offset={0.25} stopOpacity={0.32} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={79.5}
        y1={523.53}
        x2={299.76}
        y2={673.17}
        gradientTransform="translate(-31.34 -445.03)"
        xlinkHref="#a"
      />
      <linearGradient
        id="c"
        x1={-9.53}
        y1={483.97}
        x2={484.29}
        y2={819.45}
        gradientTransform="translate(-31.34 -445.03)"
        xlinkHref="#a"
      />
      <linearGradient
        id="d"
        x1={-100.98}
        y1={567.98}
        x2={523.38}
        y2={654.82}
        gradientTransform="translate(-31.34 -445.03)"
        xlinkHref="#a"
      />
      <linearGradient
        id="e"
        x1={263.05}
        y1={469.38}
        x2={278.6}
        y2={514.49}
        gradientTransform="translate(-31.34 -445.03)"
        xlinkHref="#a"
      />
      <linearGradient
        id="f"
        x1={251.57}
        y1={506.93}
        x2={255.32}
        y2={483.31}
        gradientTransform="translate(-31.34 -445.03)"
        xlinkHref="#a"
      />
    </defs>
    <title>{"11"}</title>
    <path
      d="M351.59 247.05c-15.57 22.69-41.91 36.2-68.85 41.81S228 293 200.49 291.24c-27.3-1.77-55.28-4-82.47.16-23.46 3.59-46.63 7.75-67.51-7.22-7.82-5.61-14-13.2-19.52-21.09-15.33-22-27.22-48.92-29.9-75.71C-1.52 161.18.4 134 8.6 109.15a139.19 139.19 0 0 1 16.2-33.7 134.08 134.08 0 0 1 9.75-12.89c.29-.36.6-.72.92-1.07A157.79 157.79 0 0 1 56.4 41.56a193.57 193.57 0 0 1 26.85-17.78A198.5 198.5 0 0 1 129 5.46a162 162 0 0 1 61.18-4.29c36.73 4.73 72.1 24.62 91.88 55.94 16.26 25.73 22.37 58.65 45.57 78.36 5.79 4.92 12.43 8.79 18 13.95 9.09 8.39 15 19.89 17.92 31.9a82.77 82.77 0 0 1-11.96 65.73Z"
      fill="#4FD1C5"
      opacity={0.18}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      d="M208.37 39.08c-1.66-1.56-3.26-3.32-5.4-4.11a11.25 11.25 0 0 0-6.77.14 63.1 63.1 0 0 1-6.62 1.89c-2.21.36-4.49.2-6.71.55a1.3 1.3 0 0 0-.64.2 1.13 1.13 0 0 0-.41.94c0 1.34 1.38 2.26 2.64 2.72a13.41 13.41 0 0 0 5.1.81c-.17 1.14 1.19 1.89 2.33 2.11a11.73 11.73 0 0 0 4.42 0 3 3 0 0 0 2.53 1.67 2.9 2.9 0 0 0 2.65-1.53 3.66 3.66 0 0 0 3.34 1.6c1.3 0 2.57-.4 3.86-.51a15.88 15.88 0 0 1 5.47.75c.93.26 7.8.73 8.45-.32s-5.57-1.55-6.39-1.89a25.18 25.18 0 0 1-7.85-5.02Z"
      fill="#4FD1C5"
    />
    <path
      d="M208 39.86c-1.59-1.62-3.12-3.43-5.21-4.29a11 11 0 0 0-6.73-.09 60.61 60.61 0 0 1-6.63 1.66c-2.21.29-4.47 0-6.68.33a1.29 1.29 0 0 0-.64.19 1.11 1.11 0 0 0-.44.92c0 1.34 1.27 2.3 2.51 2.8a13.39 13.39 0 0 0 5 1c-.21 1.14 1.11 1.93 2.24 2.18a11.53 11.53 0 0 0 4.38.12 2.84 2.84 0 0 0 5.13.39 3.64 3.64 0 0 0 3.26 1.71c1.29 0 2.56-.31 3.85-.38a15.53 15.53 0 0 1 5.4.93c.91.28 2.64 1 3.32-.07s-.39-1.71-1.19-2.07a24.8 24.8 0 0 1-7.57-5.33Z"
      fill="url(#a)"
    />
    <path
      d="M186.52 85.79c-.41 4.92-6.9 6.27-11.84 6.36a540.15 540.15 0 0 0-62.76 4.74c-5 .67-10.07 1.46-14.3 4.14-3 1.9-5.37 4.64-8.2 6.79-10.94 8.31-26.66 6.33-39.27.88A22.59 22.59 0 0 1 30.71 123a22.56 22.56 0 0 1-20.86-12.1 4.48 4.48 0 0 0-1.25-1.73 139.19 139.19 0 0 1 16.2-33.7 134.08 134.08 0 0 1 9.75-12.89 29.42 29.42 0 0 1 1.27 2.87 7.45 7.45 0 0 1-.35-3.94 157.06 157.06 0 0 1 20.93-20c8.42-3.76 18.39-5.38 26.92-2.07 7 2.71 12.73 9.72 12.07 17.22 4.24-6.59 13.12-8.07 20.94-8.44a12.16 12.16 0 0 1 5.73.7c3.1 1.46 4.45 5.16 4.84 8.57s.18 7 1.47 10.14c2.95-4.09 9.45-4.35 13.54-1.4s5.94 8.24 6.05 13.28a55.19 55.19 0 0 1 29.57-1.77c4.3.98 9.36 3.66 8.99 8.05Z"
      fill="#fff"
    />
    <path
      d="M190.1 103.32 176 231.75 174.48 246c-26.35-25.53-108.56-83.83-108.56-83.83l35.9-87.07 3.72 1.19Z"
      fill="#4FD1C5"
    />
    <path
      d="M65.91 162.18s47.2-63.76 124.19-58.87c0 0-74.64 4.26-124.19 58.87Z"
      fill="url(#b)"
    />
    <path fill="url(#c)" d="m101.82 75.11 72.66 170.9L100.71 77.8l1.11-2.69z" />
    <path
      d="M217.56 104.25c15.85 5.77 28.73 20.25 45.59 20.8 7.79.26 15.3-2.59 22.57-5.39-11.69 5.88-17.86 20.91-13.66 33.3-5-9.18-18.09-9-27.18-14.14-8.36-4.74-13.14-14.07-21-19.53-4.77-3.29-10.34-4.91-16-6.11-3.89-.82-15.85-.71-18.36-4.14-7.19-9.86 24.41-6.04 28.04-4.79ZM209.46 258.88c14.35.73 28.37-3.76 42.23-7.54s28.53-6.91 42.48-3.46 25.84 13.39 35 24.67a49.37 49.37 0 0 0-33.06 7.8c-8.49-11.2-23.84-14.7-37.89-14.7s-28.19 2.71-42.08.57c-15.27-2.36-32.58-11.6-40.21-25.35a43.72 43.72 0 0 0 33.53 18.01ZM72.66 212c6.7 8 15.43 14.08 22.89 21.41s13.92 16.7 14 27.16a26.49 26.49 0 0 1 18-10.57c-5.33-2.5-7.6-8.69-11-13.47-3-4.11-7-7.32-11-10.37-10.48-7.9-21.61-15.27-29.93-25.42-8.12-9.9-12.84-22.57-10.28-35.37-10.86 11.97-1.46 36.08 7.32 46.63Z"
      fill="#4FD1C5"
      opacity={0.39}
      style={{
        isolation: "isolate",
      }}
    />
    <path
      fill="none"
      stroke="#fff"
      strokeMiterlimit={10}
      d="m100.71 77.8-34.8 146.54-34.92 38.74M65.91 224.33l108.57 21.68"
    />
    <path
      d="M176 231.75 174.48 246c-26.35-25.53-108.56-83.83-108.56-83.83l35.9-87.07 3.72 1.19a24 24 0 0 1-.67 5.34c-1.61 7.82-4.51 15.32-6.14 23.17-1.17 5.67-2.32 11.35-3.49 17-.56 2.76-1.24 14.2-3.24 15.84a132.82 132.82 0 0 1 62.08-28.15c-11.16 2.59-21.05 9.38-28.83 17.8s-13.6 18.47-18.78 28.68c9.9 7.41 14.43 20.06 23.34 28.62 5.61 5.39 12.81 9 18 14.8 4.22 4.74 6.87 10.67 10.63 15.78a43.72 43.72 0 0 0 12.21 11.3c1.84 1.14 3.87 2.24 4.91 4.14a6.67 6.67 0 0 1 .44 1.14Z"
      fill="url(#d)"
    />
    <path
      d="M219 193.3c-12.8-1.82-26 8.76-27 21.65-.3 3.86.47 8 3.11 10.83 2.84 3 7.27 4 11.42 4.22a48.41 48.41 0 0 0 25.34-5.52c1.48-.78 3-1.67 4.71-1.52a9.24 9.24 0 0 1 3.85 1.71 33.19 33.19 0 0 0 30.72 1.87c4.79-2.21 9.52-5.68 14.76-5 2.5.32 4.77 1.57 7.06 2.62 18.87 8.67 43.09 3.68 57-11.73 2.83-3.13 5.38-7.23 4.37-11.33a11.93 11.93 0 0 0-3.43-5.4c-7-7-17.37-10-27.3-9.7a8.07 8.07 0 0 1-4.15-.52c-1.35-.73-2.1-2.19-2.87-3.52-8.71-15-27.93-18.28-42.74-11.5-5.06-12.76-19.32-4.05-27.69-1.11-12.04 4.22-22.5 11.5-27.16 23.95Z"
      fill="#fff"
    />
    <path
      d="M236.12 55.12a1.24 1.24 0 0 1-.18.22 3.7 3.7 0 0 1-2.51 1.09 10.37 10.37 0 0 1-1.93 0 56.67 56.67 0 0 1-16.66-4 29.76 29.76 0 0 0-4.18-1.6c-1.46-.35-3-.41-4.45-.73a13.21 13.21 0 0 1-5.7-2.83A5.32 5.32 0 0 1 199.4 46a2.38 2.38 0 0 1-.2-2.74c.83-1.16 2.62-.92 3.93-.37a15.13 15.13 0 0 1 3.14 1.76c1.34.29 2.62 1.15 4 1.52 3 .8 6.07-.82 9.15-1.22 3.45-.45 6.9.67 10.13 2 2.18.88 4.41 1.9 5.89 3.72a5.35 5.35 0 0 1 .8 1.31 3.33 3.33 0 0 1-.12 3.14Z"
      fill="#4FD1C5"
    />
    <path
      d="M254.78 53.05a3.07 3.07 0 0 1-1.78 2.37 7.38 7.38 0 0 1-3 .64 28.52 28.52 0 0 1-6.19-.32c1.14.77 2.28 1.54 3.43 2.3a5.66 5.66 0 0 1-3 .56 16.07 16.07 0 0 1-4.81-1.27 1.89 1.89 0 0 1-1.87.92 5.49 5.49 0 0 1-2.07-.75l-2.06-1.07-1.25-.65a4.56 4.56 0 0 1-1.31-.9 1.9 1.9 0 0 1-.3-.44 6.31 6.31 0 0 1-.47-1.18c-.61-1.91-.75-3.42 1.76-2.77 1.46.38 2.89 1 4.37 1.43a9.58 9.58 0 0 0 1.4.26 26.9 26.9 0 0 0 5.53-.11 39.42 39.42 0 0 1 11.62.98Z"
      fill="#4FD1C5"
    />
    <path
      d="M220.1 44.45c2.56-1.67 4.5-4.07 7.38-5.25a15 15 0 0 1 4.24-.87 37.57 37.57 0 0 1 6-.17c5 .33 9.79 2.17 14.78 2.25 1.59 0 3.18-.13 4.76 0a3.37 3.37 0 0 1-2 2.76 7.5 7.5 0 0 1-3.46.65 1 1 0 0 1-.34 1.93 4 4 0 0 0 2.79 1.25c.84.15 1.87.69.6 1.14a12.73 12.73 0 0 1-3.36.41 6.22 6.22 0 0 1-3.6-.84L249.4 49a6.2 6.2 0 0 1-5.77-.14c.35.58-.19 1.36-.85 1.51a3.17 3.17 0 0 1-2-.4 23.52 23.52 0 0 0-5.46-2c-3.81-.67-7.64.71-11.45 1.36-2.54.43-9.57.7-10.31-2.79a14.73 14.73 0 0 0 6.54-2.09Z"
      fill="#4FD1C5"
    />
    <path
      d="M197.24 43.78a1.72 1.72 0 0 0-.66.43 2.33 2.33 0 0 0-.57 2.55 2.81 2.81 0 0 1 1.6-1 4.08 4.08 0 0 1 2.22.47l1.12.47c-.17-.07-.47-1.18-.58-1.4a4.59 4.59 0 0 0-.84-1.16 2.53 2.53 0 0 0-2.29-.36Z"
      fill="#fff"
    />
    <path
      d="M223 47.07a29.74 29.74 0 0 0 4.64-2.27 23.58 23.58 0 0 1 4.36-2.69 10.75 10.75 0 0 1 2.69-.51 31.34 31.34 0 0 1 8.7.44c3.74.72 7.47.63 11.27.8a2.7 2.7 0 0 1-2.44 1.2 1.17 1.17 0 0 1-.27 1.62 1.27 1.27 0 0 1-.45.19 9 9 0 0 0 3.31 1.46 4.62 4.62 0 0 1-3.19 1.19 8.34 8.34 0 0 1-3.36-.81c0 .72 1.1 1.31.71 1.92a.76.76 0 0 1-.38.28c-1.42.64-3.06 0-4.48-.69a1.57 1.57 0 0 1-1.21 1.36 3 3 0 0 1-1.64-.28c-1.77-.69-3.48-1.54-5.29-2.09a9.81 9.81 0 0 0-5.6-.28c-.61.17-1.19.43-1.8.6a6.29 6.29 0 0 1-5.57-1.44Z"
      fill="url(#e)"
    />
    <path
      d="M244.24 58.6a16.07 16.07 0 0 1-4.81-1.27 1.89 1.89 0 0 1-1.87.92 5.49 5.49 0 0 1-2.07-.75l-2.06-1.07a10.37 10.37 0 0 1-1.93 0 56.67 56.67 0 0 1-16.66-4 29.76 29.76 0 0 0-4.18-1.6c-1.46-.35-3-.41-4.45-.73a13.21 13.21 0 0 1-5.7-2.83A5.32 5.32 0 0 1 199.4 46v-.13a1.89 1.89 0 0 1 .72-2c2.69 2.92 6.62 4.31 10.41 5.5 5.26 1.65 10.58 3.13 16 4.3 1.37.3 2.74.57 4.11.82q2.69.51 5.37.9l1 .15a1.5 1.5 0 0 0 1-.08c.21-.12.37-.33.61-.39a1.06 1.06 0 0 1 .81.29c1.07.77 4.3 1.56 4.85 2.64a.67.67 0 0 1-.04.6Z"
      fill="url(#f)"
    />
    <path
      d="M197.05 63.45a5.34 5.34 0 0 0 1.69-.65 7.34 7.34 0 0 1 5.56-.31 3.4 3.4 0 0 0-2.51.77q3.87 0 7.73-.23l-2.61-.92a7.34 7.34 0 0 1 6.69-.11c-.61-1.37-2.33-1.59-3.76-1.61a6.38 6.38 0 0 0-3.3.6c-.45.27-.7.68-1.23.72s-1.18-.38-1.68-.47a7.43 7.43 0 0 0-6.58 2.21ZM219 70.17a3.41 3.41 0 0 0 1.31-.64 4.45 4.45 0 0 1 4.3-.31 2.34 2.34 0 0 0-1.91.75q3 0 6-.23l-2-.91a4.55 4.55 0 0 1 5.17-.08c-.47-1.37-1.8-1.59-2.9-1.61a3.9 3.9 0 0 0-2.55.6c-.35.27-.55.67-1 .72s-.92-.39-1.3-.47a5 5 0 0 0-5.12 2.18ZM172.13 65.75a3.23 3.23 0 0 0 1.31-.65 4.48 4.48 0 0 1 4.3-.3 2.29 2.29 0 0 0-2 .76q3 0 6-.23l-2-.91a4.58 4.58 0 0 1 5.18-.09c-.48-1.36-1.81-1.58-2.91-1.6a3.9 3.9 0 0 0-2.55.6c-.35.27-.54.67-1 .71s-.92-.38-1.3-.46a5 5 0 0 0-5.03 2.17Z"
      fill="#4FD1C5"
    />
  </svg>
);

export default NoResults;
